import createSaga from './createSaga'
import listSaga from './listSaga'
import oneSaga from './oneSaga'
import editSaga from './editSaga'
import publishListSaga from './publishListSaga'
import prePublishListSaga from './prePublishListSaga'
import deleteEditListSaga from './deleteSaga'

const editListSagas = [
    createSaga(),
    listSaga(),
    oneSaga(),
    editSaga(),
    publishListSaga(),
    prePublishListSaga(),
    deleteEditListSaga()
]

export default editListSagas
